import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';

import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Input } from 'ui-components/components/input';
import { Button } from 'ui-components/components/button';
import { FlexColumn } from 'ui-components/components/flex';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import Global from '../../../../../store/global-selectors';
import { US, AU, GB } from '../../../../../constants/country-codes';
import ImperialWeightInput from './imperial-weight-input';
import MetricWeightInput from './metric-weight-input';
import messages from '../messages';

const defaultLabels = {
  origin: messages.originZip,
  destination: messages.destinationZip,
};

const countryCalculatorLabels = {
  [AU]: {
    origin: messages.originPostcode,
    destination: messages.destinationPostcode,
  },
  [GB]: {
    origin: messages.originPostcode,
    destination: messages.destinationPostcode,
  },
  [US]: defaultLabels,
};

export const CalculatorSection = ({
  originZip,
  destinationZip,
  weight,
  isImperial,
  maxZipLength,
  intl,
  handleGetRates,
  handleOriginZipChange,
  handleDestinationZipChange,
  handleWeightChange,
  className,
  weightInputClassName,
  weightContainerClassName,
  stylesheet: style,
  buttonTheme = THEME_CONSTANTS.secondary,
  gap = Gap.Space12,
  isHorizontalLayout = false,
}) => {
  const sellerHomeCountry = useSelector(Global.selectSellerHomeCountry);
  const labels = countryCalculatorLabels[sellerHomeCountry] || defaultLabels;

  const ContainerComponent = isHorizontalLayout ? FlexRow : FlexColumn;

  return (
    <ContainerComponent className={className} gap={gap}>
      <FlexRow className={style['zip-codes']} gap={Gap.Space8}>
        <FlexColumn className={style['origin-zip']}>
          <div className={style['input-label']}>
            <FormattedMessage {...labels.origin} />
          </div>
          <Input
            className={style['zip-input']}
            maxLength={maxZipLength}
            onChange={handleOriginZipChange}
            placeholder={intl.formatMessage(labels.origin)}
            type='text'
            value={originZip}
            version='version2'
          />
        </FlexColumn>
        <FontAwesomeIcon className={style['zip-arrow']} icon={faArrowRight} />
        <FlexColumn className={style['destination-zip']}>
          <div className={style['input-label']}>
            <FormattedMessage {...labels.destination} />
          </div>
          <Input
            className={style['zip-input']}
            maxLength={maxZipLength}
            onChange={handleDestinationZipChange}
            placeholder={intl.formatMessage(labels.destination)}
            type='text'
            value={destinationZip}
            version='version2'
          />
        </FlexColumn>
      </FlexRow>

      <FlexColumn className={style['weight-inputs']}>
        <div className={style['input-label']}>
          <FormattedMessage {...messages.weight} />
        </div>
        {isImperial ? (
          <ImperialWeightInput
            className={style['weight-inputs-container']}
            onChange={handleWeightChange}
            weight={weight}
            weightContainerClassName={weightContainerClassName}
            weightInputClassName={weightInputClassName}
          />
        ) : (
          <MetricWeightInput
            className={style['weight-inputs-container']}
            onChange={handleWeightChange}
            weight={weight}
            weightContainerClassName={weightContainerClassName}
            weightInputClassName={weightInputClassName}
          />
        )}
      </FlexColumn>

      <Button className={style['get-rates-button']} onClick={handleGetRates} theme={buttonTheme}>
        <FormattedMessage {...messages.getRates} />
      </Button>
    </ContainerComponent>
  );
};
